import React, { useEffect, useRef, useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Typography, Row, Col, Button, Switch, InputNumber, Steps, message, Card } from "antd";

import { plans, bundles } from "../../data/data";
import "../Plans/Plans.scss";
import "./PlanActivationAndPayment.scss"
import "../../../../../../styles/helper.scss"
import axios from "axios";
import ENVIRONMENT from '../../../../../../environments'
import { CheckOutlined, LoadingOutlined } from "@ant-design/icons";
import SaveCardFlow from "../../../SaveCardFlow";

const { Paragraph } = Typography;
const { Step } = Steps
const stripePromise = loadStripe(ENVIRONMENT.STRIPE_PUBLISH_KEY);
const CUSTOMER_USERNAME = localStorage.getItem('username')


const allowedKeys = [
    'Backspace',
    'Delete',
    'ArrowLeft',
    'ArrowRight',
];

const PlanActivationAndPayment = ({
    selectedPlanName, 
    signUpFlow, 
    cardStatus, 
    updateUserAccountInformation = () => {}, 
    loadUserRequestStatus, 
    closeSubscriptionUpgrade, 
    requestType, 
    selectedBundleQuantity, 
    setSuccessModalVisible = () => {}, 
    setShowPaymentFailureModal = () => {}, 
    setSystemErrorModal = () => {}, 
    annualSetting,
    setAnnualSetting
}) => {
    const [plan, setSelectedPlan] = useState(null)
    const [isAnnual, setIsAnnual] = useState(true)
    const [monthlyPrice, setMonthlyPrice] = useState(null)
    const [totalPayment, setTotalPayment] = useState(null)
    const [deleteCardFlow, setDeleteCardFlow] = useState(false)
    const [cardSaveFlowTriggered, setCardSaveFlowTriggered] = useState(false)
    const [stage, setStage] = useState(1)
    const [subscriptionType, setSubscriptionType] = useState('subscription')
    const [bundleQuantity, setBundleQuantity] = useState(1);
    const [minQuantity,] = useState({
        "Basic Bundle": 5,
        "Studio Bundle": 45,
        "ALL3D Enterprise": 1,
    });

    const deleteCardFlowRef = useRef(deleteCardFlow)

    useEffect(() => {
        if(selectedPlanName){
            let selected = plans.filter(item => item.plan_name == selectedPlanName || item.annual_plan_name == selectedPlanName)[0]
            if(!selected){
                selected = bundles.filter(item => item.name == selectedPlanName)[0]
                setSubscriptionType('bundle')
                setIsAnnual(false)
                setAnnualSetting(false)
                // set initial amount for bundle
                if(selectedBundleQuantity){
                    // BundleQuantity is preselected
                    setBundleQuantity(selectedBundleQuantity)
                    setTotalPayment(selected.price * selectedBundleQuantity)
                }
                else
                    setTotalPayment(selected.price * bundleQuantity)
            }
            else{
                setSubscriptionType("subscription")
            }
            
            setSelectedPlan(selected)
        }
    }, [selectedPlanName])

    useEffect(() => {
        if (plan && subscriptionType == 'subscription') {
            setIsAnnual(annualSetting);
        }
    }, [plan, annualSetting])

    useEffect(() => {
        let monthlyAmount = null
        if (plan && subscriptionType == 'subscription') {
            if (annualSetting == false || isAnnual == false) {
                monthlyAmount = plan.priceMonthly
            }
            else {
                monthlyAmount = plan.price
            }

            setMonthlyPrice(monthlyAmount)
            if (isAnnual || annualSetting) {
                setTotalPayment(monthlyAmount * 12)
            }
            else {
                setTotalPayment(monthlyAmount)
            }
        }
        else if(plan && subscriptionType == 'bundle'){
            setMonthlyPrice(plan.price)
            setTotalPayment(plan.price * bundleQuantity)
        }
    }, [plan, isAnnual, subscriptionType, bundleQuantity])

    // Update the ref whenever count changes
  useEffect(() => {
    deleteCardFlowRef.current = deleteCardFlow;
  }, [deleteCardFlow]);

 

    const initiateConfirmation = (deleteFlow = false) => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
          
        if ((cardStatus == 1 || signUpFlow == true) && !deleteFlow) {
            setStage(2);
            return
        }

        window.addEventListener('card_saved', (e) => {
            if(deleteCardFlowRef.current){
                // delete Previous Card
                axios.post(ENVIRONMENT.GET_USER_PAYMENT_INFORMATION, {
                    'username': localStorage.getItem('username'),
                    'action': 'delete_previous'
                }).then((res) => {
                    updateUserAccountInformation(res.data)
                    setStage(1)
                    setDeleteCardFlow(false)
                })
            }
            let action = e.detail.action;
            setCardSaveFlowTriggered(false);
            if (action == 'save_card') {
                loadUserRequestStatus();
                setStage(2);
            }

        }, false);

        if (cardStatus == 0 || deleteFlow) {
            let child_window = window.open('/save-card?action=save_card', '', "width=600,height=600");
            let refreshInterval = setInterval(() => {
                if(child_window.closed) {
                setCardSaveFlowTriggered(false);
                clearInterval(refreshInterval);
                }
            }, 500);
            setCardSaveFlowTriggered(true);
        }
    }

    const changePaymentMethod = () => {
        // Delete the payment method and show form 
        setDeleteCardFlow(true)
        initiateConfirmation(true)
    }

    const customDot = (dot, { status }) => {
        switch (status) {
          case "process":
            return <div className="custom-dot-process" />;
          case "finish":
            return (
              <div className="custom-dot-finish">
                {" "}
                <CheckOutlined className="check-icon" />{" "}
              </div>
            );
          default:
            return dot;
        }
      };


    return (
        <div style={{ width: '100%' }}>
            {selectedPlanName !== 'free_trial' &&
                <div className="steps-tab-register">
                    <Steps progressDot={customDot}
                    labelPlacement="vertical" className='step-class' style={{ marginBottom: 0, padding: '32px 48px' }} size="small" current={stage}>
                        <Step className={`manrope f-14 `} title={<span className="manrope f-14 w-500 lh-22 black-085">Select Subscription</span>} />
                        <Step className={`manrope f-14 `} title={<span className="manrope f-14 w-500 lh-22 black-085">Review Order</span>} />
                        <Step className={`manrope f-14 `} title={<span className="manrope f-14 w-500 lh-22 black-085">Checkout</span>} />
                    </Steps>
                </div>
            }
            {plan &&
                <>
                    <div className="selected-plan-heading-gradient" >
                        <div className="manrope f-30 w-700 black-085 lh-32">
                            {plan?.title}
                        </div>
                        {plan?.description && subscriptionType == 'subscription' &&
                        <div className="manrope f-16 w-500 black-085 lh-24 mt-8">
                            {plan?.description}
                        </div>}
                    </div>
                    <div className="subscription-card" style={{ padding: '32px 25px', borderRadius: '4px' }}>
                            {stage == 1 ? 
                            subscriptionType == 'subscription' ?
                            <>
                            <div className="price-section" style={{ marginBottom: 8, alignItems: 'baseline', flexWrap: 'nowrap' }}>
                                <span style={{ whiteSpace: 'nowrap', display: 'inline-flex', alignItems: 'baseline' }}>
                                    <span className="manrope f-26 w-700 black-085" style={{ lineHeight: '1' }}>${monthlyPrice}</span>
                                    <span className="manrope f-14 w-500 black-085" style={{ lineHeight: '1' }}>/month</span>
                                </span>
                                <span className="manrope f-14 w-400 lh-22 gray-045">{isAnnual ? 'Billed annually' : 'Billed monthly'}</span>
                            </div>
                            <div className="manrope f-14 w-400 lh-22 black-085" style={{ marginBottom: 24 }}>
                                {isAnnual ? plan.annual_images_dec : plan.images_dec}
                            </div>
                            <div className="gray-billing-bg">
                            <div className="justify-space-between" style={{ marginBottom: 8 }}>
                                <span className="manrope f-14 w-600 lh-22 black-085">Your billing cycle</span>
                                <span className="manrope f-14 w-600 lh-22 black-085">
                                ${isAnnual ? (parseInt(monthlyPrice) * 12).toLocaleString() : monthlyPrice.toLocaleString()} billed {isAnnual ? 'annually' : 'monthly'}
                                </span>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <span className={`manrope f-14 lh-22 ${!isAnnual ? 'w-600' : 'w-500'} black-085`}>Monthly</span>
                                    <Switch
                                        className="blue-color"
                                        style={{ marginLeft: 8, marginRight: 8 }}
                                        checked={isAnnual}
                                        onChange={(checked) => {
                                            setIsAnnual(checked)
                                            setAnnualSetting(checked)
                                            let URLParams = new URLSearchParams(window.location.search);
                                            let plan = URLParams.get('plan')
                                            
                                            if (plan && plan.includes('annual_') && !checked) {
                                                URLParams.set('plan', plan.replace('annual_', ''))
                                            }
                                            else if (plan && !plan.includes('annual_') && checked) {
                                                URLParams.set('plan', 'annual_' + plan)
                                            }
                                            window.history.replaceState({}, '', `${window.location.pathname}?${URLParams.toString()}`);
                                        }}
                                    />
                                    <span className={`manrope f-14 lh-22 ${isAnnual ? 'w-600' : 'w-500'} black-085`}>Annually</span>
                                </div>
                                <div className={`save-discount-bg ${isAnnual ? 'blue' : 'gray'} ml-12`}>
                                    <span className={`manrope f-12 lh-20 ${isAnnual ? 'w-700 blue-18' : 'w-500 black-085'}`}>
                                        Save 17%
                                    </span>
                                </div>
                            </div>
                            </div>

                            {plan.credits_details && !signUpFlow &&
                            <div className="credit-system-bg" style={{ marginTop: 24, marginBottom: 24 }}>
                                <div className="manrope f-14 w-700 lh-22 black-085 text-left" style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                                    <img src="/img/majesticons_coins-line.svg" className="mr-8" style={{ width: 20, height: 20 }}/>
                                    Your subscription runs on credits
                                </div>
                                <div className="manrope f-14 w-500 lh-22 black-085 text-left">
                                    {isAnnual ? plan.annual_credits_details : plan.credits_details}
                                </div>
                            </div>}

                            {signUpFlow && <div>
                            <div className="manrope f-14 w-500 lh-22 black-085 text-left" style={{ marginTop: 32, marginBottom: 16 }}>
                                Your subscription includes full access to the ALL3D platform and its AI imaging features:
                            </div>
                            {isAnnual ? plan.features.map((feature, index) => (
                                <div className="text-left">
                                    <CheckOutlined className="manrope f-14 lh-22 w-700 blue text-left"  style={{ marginRight: 10 }}/>
                                    <span className="manrope f-14 w-500 lh-22 black-085 text-left">{feature}</span>
                                </div>
                            )) : plan.monthly_features.map((feature, index) => (
                                <div className="text-left">
                                    <CheckOutlined className="manrope f-14 lh-22 w-700 blue text-left"  style={{ marginRight: 10 }}/>
                                    <span className="manrope f-14 w-500 lh-22 black-085 text-left">{feature}</span>
                                </div>
                            ))}
                            <div className="manrope f-14 w-700 lh-22 black-085 text-left" style={{ marginTop: 16, marginBottom: 16 }}>
                                Plus, editing tools & features:
                            </div>
                            {plan.plus_features.map((feature, index) => (
                                <div className="text-left">
                                    <CheckOutlined className="manrope f-14 lh-22 w-700 blue text-left"  style={{ marginRight: 10 }}/>
                                    <span className="manrope f-14 w-500 lh-22 black-085 text-left">{feature}</span>
                                </div>
                            ))}

                            {plan.credits_details && 
                            <div className="credit-system-bg" style={{ marginTop: 24, marginBottom: 0 }}>
                                <div className="manrope f-16 w-700 lh-24 black-085 text-left mb-8" style={{ display: 'flex', alignItems: 'center' }}>
                                    <img src="/img/majesticons_coins-line.svg" className="mr-8" style={{ width: 20, height: 20 }}/>
                                    Your subscription runs on credits
                                </div>
                                <div className="manrope f-14 w-500 lh-22 black-085 text-left">
                                    {isAnnual ? plan.annual_credits_details : plan.credits_details}
                                </div>
                            </div>}
                            </div>}

                            {/* <div className="subscription-details">
                                Your subscription includes full access to the ALL3D platform and
                                its features including any combination of 3D/AR models, images,
                                and 360 spins within your paid quota, free access to the ALL3D
                                store, cloud storage, and sharing.
                            </div> */}

                            <div style={{ display: 'flex', gap: '12px', marginTop: 24 }}>
                                <Button className="back-btn" style={{ flex: '0 0 25%' }} onClick={closeSubscriptionUpgrade}>Back</Button>
                                <Button className="checkout-btn" style={{ flex: '0 0 calc(75% - 12px)' }} onClick={() => initiateConfirmation()}>{(cardStatus == 1 || signUpFlow) ? 'Continue to checkout': 'Add Payment Method'}</Button>
                            </div>

                            <div className="subscription-note" style={{ marginTop: 24, textAlign: 'center' }}>
                                {isAnnual ? (
                                    <span>
                                        This is an annual contract which will automatically renew each year. You may cancel at any time before the renewal date.
                                    </span>
                                ) : (
                                    <span>
                                        This is a monthly contract which will automatically renew each month. You may cancel at any time before the renewal date.
                                    </span>
                                )}
                            </div>
                            </> 
                            :
                            // Selecting a Bundle Flow
                            <>
                            <div className="price-section" style={{ marginBottom: 16 }}>
                                <div style={{ display: 'flex', alignItems: 'baseline' }}>
                                <span className="manrope f-26 w-700 lh-40 black-085">${monthlyPrice}</span>
                                <span className="manrope f-14 w-600 lh-40 black-085">/image</span>
                                </div>
                                <Paragraph className="manrope black-085 f-14 lh-28 w-400 gray-045" style={{marginBottom: 0}}>One-time purchase</Paragraph>
                            </div>
                            <div className="justify-space-between">
                                <div className="justify-in-start">
                                    <div className="manrope f-14 lh-22 black-085 w-600 mr-8">QTY</div>
                                        <InputNumber style={{ height: 33 }}
                                        min={minQuantity[plan.title] || 1}
                                            onKeyDown={(e) => {
                                                if ((["-", ".", " "].includes(e.key)) || (/[a-zA-Z\s]/.test(e.key) && !allowedKeys.includes(e.key))) {
                                                    e.preventDefault();
                                                }
                                            }}

                                            value={bundleQuantity}
                                            onChange={(value) => setBundleQuantity(value)}
                                            className="manrope f-16 lh-24 black-085 w-400" />
                                    </div>
                                    <div className="justify-in-end total-payment-bg">
                                        <div className="manrope f-14 lh-22 black-085 w-700 mr-20">
                                            Total
                                        </div>
                                        <div className="manrope f-14 lh-22 black-085 w-500">
                                            ${totalPayment?.toLocaleString()}
                                        </div>
                                    </div>
                            </div>


                            {signUpFlow && <div>
                            <div className="manrope f-14 w-500 lh-22 black-085 text-left" style={{ marginTop: 32, marginBottom: 16 }}>
                            Your bundle includes full access to the ALL3D platform and its AI imaging features:
                            </div>
                            {plan.features.map((feature, index) => (
                                <div className="text-left">
                                    <CheckOutlined className="manrope f-14 lh-22 w-700 blue text-left"  style={{ marginRight: 10 }}/>
                                    <span className="manrope f-14 w-500 lh-22 black-085 text-left">{feature}</span>
                                </div>
                            ))}
                            <div className="manrope f-14 w-700 lh-22 black-085 text-left" style={{ marginTop: 16, marginBottom: 16 }}>
                                Plus, editing tools & features:
                            </div>
                            {plan.plus_features.map((feature, index) => (
                                <div className="text-left">
                                    <CheckOutlined className="manrope f-14 lh-22 w-700 blue text-left"  style={{ marginRight: 10 }}/>
                                    <span className="manrope f-14 w-500 lh-22 black-085 text-left">{feature}</span>
                                </div>
                            ))}

                            {plan.credits_details &&
                            <div className="credit-system-bg" style={{ marginTop: 32, marginBottom: 32 }}>
                                <div className="manrope f-14 w-700 lh-22 black-085 text-left">
                                    <img src="/img/majesticons_coins-line.svg" className="mr-8" style={{ width: 20, height: 20 }}/>
                                    Your subscription runs on credits
                                </div>
                                <div className="manrope f-14 w-500 lh-22 black-085 text-left">
                                    Your purchase includes <b>{(plan.credit_multiplier*bundleQuantity).toLocaleString()} credits</b> each month, redeemable at <b>{plan.credit_multiplier} credits per final 4K image</b>. Unused credits expire 1 year from the purchase date. No rollovers.
                                </div>
                            </div>}
                            </div>}

                            <Button className="checkout-btn" style={{ marginTop: 20 }} onClick={() => initiateConfirmation()}>{(cardStatus == 1 || signUpFlow) ? 'Continue to Checkout': 'Add Payment Method'}</Button>
                            <div className="subscription-note">
                                <span>
                                Your total price for this bundle is ${totalPayment}. This is a one-time purchase. You may purchase more bundles or upgrade to a subscription at any time.
                                </span>
                            </div>
                            </>
                            :
                             <PaymentConfirmation
                                totalAmount={totalPayment}
                                plan={selectedPlanName}
                                annualPlan={isAnnual}
                                setStage={setStage}
                                signUpFlow={signUpFlow}
                                cardStatus={cardStatus}
                                closeSubscriptionUpgrade={closeSubscriptionUpgrade}
                                loadUserRequestStatus={loadUserRequestStatus}
                                requestType={requestType}
                                bundleQuantity={bundleQuantity}
                                subscriptionType={subscriptionType}
                                changePaymentMethod={changePaymentMethod}
                                setSuccessModalVisible={setSuccessModalVisible}
                                setShowPaymentFailureModal={setShowPaymentFailureModal}
                                setSystemErrorModal={setSystemErrorModal}
                            />
                            }
                        </div>
                    </>
                }
            {signUpFlow && 
            <div className='text-center manrope f-12 w-400 grey-66 mt-40 mb-40' style={{ padding: '0 48px' }}>By continuing, you accept ALL3D's <a href="https://all3d.ai/terms">Terms of Use</a> and <a href="https://all3d.ai/privacy">Privacy Policy</a>.</div>
            }
        </div>
    );
};

const PaymentConfirmation = ({ totalAmount, plan, annualPlan, setStage, signUpFlow, cardStatus, closeSubscriptionUpgrade, loadUserRequestStatus, requestType, bundleQuantity, subscriptionType, changePaymentMethod, setSuccessModalVisible, setShowPaymentFailureModal, setSystemErrorModal}) => {
    const [paymentLoader, setPaymentLoader] = useState(false)
    const [paymentInformation, setPaymentInformation] = useState(null)

    useEffect(() => {

        let payload = {
            "username": localStorage.getItem('username'),
            "action": "getinfo"
          }
          axios.post(ENVIRONMENT.GET_USER_PAYMENT_INFORMATION, payload)
          .then(res => {
            setPaymentInformation(res.data['card_information'])
          });

    }, [])

    const handlePaymentAndSubscriptionActivation = () => {
        setPaymentLoader(true)
        let payload = {
            subscription_type: annualPlan ? "annual_" + plan : plan,
            username: localStorage.getItem('username'),
            annual_subscription: annualPlan
        }
        if(subscriptionType == 'bundle' && bundleQuantity){
            payload['bundle_quantity'] = bundleQuantity
        }
        // Subscription Activation
        axios.post(ENVIRONMENT.UPGRADE_SUBSCRIPTION, payload).then(res => {
            setPaymentLoader(false)
           
            closeSubscriptionUpgrade()
            if(res.data.status_code == 400){
                if(res.data.error_type == 'payment_failed')
                    setShowPaymentFailureModal(true)
                else
                    setSystemErrorModal(true)
            }
            else{
                loadUserRequestStatus();
                setSuccessModalVisible(true)
            }
        })
    }

    return (
        <span>
            {
                signUpFlow ?
                <SaveCardFlow
                totalAmount={totalAmount}
                account_details_form={false}
                signUpFlow={signUpFlow}
                plan={plan}
                isAnnual={annualPlan}
                subscriptionType={subscriptionType}
                bundleQuantity={bundleQuantity}
                setCardSaveFailure={() => alert('Card save failed')}/>
                :
                <span>
                    { (cardStatus == 1 && paymentInformation != null) ? 
                    <div>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 24 }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '24px' }}>
                                <span className="manrope f-16 w-600 lh-24 black-085">
                                    {paymentInformation[0].card.brand.charAt(0).toUpperCase() + paymentInformation[0].card.brand.slice(1)}
                                </span>
                                <span className="manrope f-16 w-600 lh-24 black-085">
                                    ****{paymentInformation[0].card.last4}
                                </span>
                                <span className="manrope f-16 w-400 lh-24 black-085">
                                    Expires {String(paymentInformation[0].card.exp_month).padStart(2, "0")}/{paymentInformation[0].card.exp_year}
                                </span>
                            </div>
                            <a onClick={changePaymentMethod} className="manrope f-16 w-400 lh-24 blue" style={{ cursor: 'pointer' }}>
                                Change payment method
                            </a>
                        </div>
                        
                        <div style={{ display: 'flex', gap: '12px', marginTop: 24 }}>
                            <Button onClick={() => setStage(1)} className="back-btn" style={{ flex: '0 0 25%' }}>
                                Back
                            </Button>
                            <Button 
                                onClick={() => handlePaymentAndSubscriptionActivation()} 
                                disabled={paymentLoader} 
                                className="checkout-btn" 
                                style={{ flex: '0 0 calc(75% - 12px)' }}>
                                {paymentLoader ? <LoadingOutlined className="manrope f-14" /> : ''} Pay ${totalAmount?.toLocaleString()}
                            </Button>
                        </div>

                        <div className="subscription-note" style={{ marginTop: 24, textAlign: 'center' }}>
                            {subscriptionType === 'bundle' ? (
                                <span>
                                    This is a one-time purchase. You may purchase more bundles or upgrade to a subscription at any time.
                                </span>
                            ) : annualPlan ? (
                                <span>
                                    This is an annual contract which will automatically renew each year. You may cancel at any time before the renewal date.
                                </span>
                            ) : (
                                <span>
                                    This is a monthly contract which will automatically renew each month. You may cancel at any time before the renewal date.
                                </span>
                            )}
                        </div>
                    </div>:
                    <LoadingOutlined className="manrope f-16" />
                    }
                </span>
                
            }
        </span>
    );


}

export default PlanActivationAndPayment;
